import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const increaseCartFn = (redBody) => {
  try {
    const response = axiosInstance.post(API_URLS.increaseCart, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
